import $ from 'jquery';

const $window = $(window);
const form = $('#frm-faq-form');
const messenger = $('.faq-form-msg');

form.on('submit', async function (e) {
    $window.trigger('loader:show');
    e.preventDefault();

    const form = $(this)[0];

    const formData = new FormData(form);

    const data = await send(formData);

    validData(data);
    $window.trigger('loader:hide');
});

const send = async filter => {
    try {
        const response = await fetch(SITE_PARAMS.site_url + '/wp-json/kvop/v1/faq-send', {
            method: 'POST',
            body: filter,
        });
        const result = await response.json();
        return result;
    } catch (e) {
        console.log(e);
        return null;
    }
};

const validData = data => {
    messenger.removeClass('form-msg__success, form-msg__err');
    form.find(
        '#frm-faq-form-faq_name, #frm-faq-form-kid_phone, #frm-faq-form-kid_email, #frm-faq-form-text'
    ).val('');

    'status' in data && data.status
        ? messenger.addClass('form-msg__success')
        : messenger.addClass('form-msg__err');

    messenger.html(data.message).show(300);
};
